import React from "react";
import "styles/OnboardingTutorial.css";
import PageLayout from "components/PageLayout";

const LOGO_SRC =
  "/static/media/BiosciencesAndTechnology.68f99ceb334dfcde911552aca53e4fe9.svg";

const OnboardingTutorial = ({ onNextClick }) => {
  return (
    <PageLayout>
      <div className="ob-paper">
        <div className="tc-header">
          <img
            src={LOGO_SRC}
            alt="Institute of Biosciences and Technology"
            className="logo-image"
          />
        </div>

        <div className="tc-divider" />

        <h2 className="ob-title">Onboarding Tutorial</h2>

        <div className="ob-content">
          <p className="ob-greeting">Hello!</p>

          <p>
            Welcome to Texas A&amp;M Health’s PROVENANCE Clinicogenomic Data
            Center. Enjoy perusing the tools and datasets we are curating.
            You’ll notice we are using state-of-the-art data governance and
            privacy-preserving tools to power patient-centric, federated
            sharing, federated learning, and privacy-preserving approaches to
            power a data ecosystem optimized for the age of AI.
          </p>

          <p>
            Our goals are to document the patient journey better and provide
            improved agency and transparency for data stewards and patients. We
            would welcome your feedback. Ahead of access to the PROVENANCE
            platform, we would ask you to follow an onboarding process with
            proper registration. The tutorial you can read after login is the
            first step to learning about our platform.
          </p>
        </div>

        <button type="button" className="ob-next" onClick={onNextClick}>
          NEXT
        </button>
      </div>
    </PageLayout>
  );
};

export default OnboardingTutorial;